import { usePwaStore } from "@/lib/pwa/pwa-store";

export async function registerServiceWorker(): Promise<void> {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;

  try {
    const registration = await navigator.serviceWorker.register("/sw.js", {
      scope: "/",
    });

    registration.addEventListener("updatefound", () => {
      const newWorker = registration.installing;
      if (!newWorker) return;

      newWorker.addEventListener("statechange", () => {
        if (
          newWorker.state === "installed" &&
          navigator.serviceWorker.controller
        ) {
          usePwaStore.getState().setUpdateAvailable(true);
        }
      });
    });
  } catch (error) {
    console.error("Service worker registration failed:", error);
  }
}
